import React, { useState } from 'react';
import './App.css';
import Footer from './Footer';

const Gallery2 = () => {
  const [activeForm, setActiveForm] = useState('Wedding Events');

  // Manually added images for each category
  const galleryImages = {
    'Wedding Events': [
       '/images/wed20.webp',
       '/images/wed21.webp',
       '/images/wed22.webp',
       '/images/wed23.webp',
      '/images/shoot7.webp',
      '/images/shoot4.webp',
      '/images/shoot5.webp',
      '/images/serv5.webp',
      '/images/ser3.webp',
      '/images/ser2.webp',
      '/images/shoot7.webp',
      '/images/coco1.webp',
      '/images/bride.webp',

    ],
    'Special Events': [
      '/images/spec20.webp',
      '/images/spec21.webp',
      '/images/spec22.webp',
      '/images/spec23.webp',
      '/images/spec24.webp',
      '/images/spec25.webp',
      '/images/spec26.webp',
      '/images/special3.webp',
      '/images/soecial2.webp',
      '/images/occation.webp',
      '/images/birthday.webp',


    ],
    'Spend the Day': [
      '/images/dayout4.webp',
      '/images/dayout3.webp',
      '/images/dayout2.webp',
      '/images/dayout.webp',
      '/images/pacl2.webp',
      '/images/pool.webp'
    ],
    'Cocoloco Awrudhu': [
      '/images/aw1.jpg',
      '/images/aw2.jpg',
      '/images/aw3.jpg',
      '/images/aw4.jpg',
      '/images/special1.webp',
      '/images/company.webp'
    ],
    'Photo Shoot': [
      '/images/shoot20.webp',
      '/images/shoot21.webp',
      '/images/shoot22.webp',
      '/images/shoot8.webp',
      '/images/shoot9.webp',
      '/images/shoot6.webp',
      '/images/shoot3.webp',
      '/images/shoot2.webp',
      '/images/shoot15.webp',
      '/images/shoot14.webp',
      '/images/shoot12.webp',
      '/images/shoot13.webp',
      '/images/shoot11.webp',
      '/images/shoot10.webp',

    ],
    'Food': [

      '/images/food20.webp',
      '/images/food21.webp',
      '/images/sappayama1.jpeg',
      '/images/kaha1.jpeg',
      '/images/biriyani1.jpeg',
      '/images/fried1.jpeg',
      '/images/kottu1.jpeg',
      '/images/kulla1.jpeg'
    ],
    'Property': [
      '/images/room4.webp',
      '/images/room3.webp',
      '/images/room2.webp',
      '/images/room.webp',
      '/images/room1.webp',
      '/images/pacl9.webp',
      '/images/pacl8.webp',
      '/images/pacl6.webp',
      '/images/pool20.webp',
      '/images/garden23.webp',
      '/images/accomedartion.webp'
    ]
  };

  return (
    <div>
      <div className="full-gallery-heading1">
        <h1>Our Gallery</h1>
        <p>
          Explore our gallery collection, capturing the happiest moments in our customers' lives.
        </p>
      </div>

      <div className="full-gallery-container">
        <div className="galleries-container">
          <div className="galleries-button-group">
            {Object.keys(galleryImages).map((category) => (
              <button
                key={category}
                onClick={() => setActiveForm(category)}
                className={`galleries-form-toggle-button ${activeForm === category ? 'active' : ''}`}
              >
                {category}
              </button>
            ))}
          </div>

          <div className="galleries-images">
            {galleryImages[activeForm] && galleryImages[activeForm].length > 0 ? (
              <ul className="image-grid">
                {galleryImages[activeForm].map((imageSrc, index) => (
                  <li key={index} className="galleries-image-item">
                    <img src={imageSrc} className="galleries-image" />
                  </li>
                ))}
              </ul>
            ) : (
              <p>No images available for {activeForm}</p>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Gallery2;
